<!-- my-loader.component.html -->
<!--<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="assets/icons/custom//loader.svg" />
        <span class="loading-message">Please wait...</span>
    </div>
</div>-->
<div class="loading-indicator" *ngIf="loading">
    <mat-spinner diameter="50" strokeWidth="5"></mat-spinner>
</div>
